<template>
  <div class="listOfCommodities">
    <mescroll-vue ref="mescroll" :up="mescrollUp" @init="mescrollInit">
      <!-- 搜索框 -->
      <!-- <searchContent inputtype="tosearchBack"></searchContent> -->
      <!-- <searchContent inputtype="tosearce"></searchContent>
      <searchContent inputtype="serching" v-model="value"></searchContent>-->
      <!-- 导航内容 -->
      <!-- <switchCard :titleClass="classTitle"> -->
        <!-- 轮播图 -->
        <!-- <div style="height: 40px;background: rgb(250, 73, 73);text-align: center;color: #fff;font-size: 16px;line-height: 40px;box-sizing: border-box;" :style="styleBox.backOne">
          积分商城
        </div> -->
        <div class="mySwipeBox" v-if="hotData.length>0">
          <div class="lunboBackground" :style="styleBox.backOne"></div>
          <van-swipe class="my-swipe" :autoplay="3000" @change="onChange">
            <van-swipe-item v-for="(itemThumb,index) in hotData" :key="index" @click="toGoods(itemThumb.productId)">
              <img class="thumbImg" v-lazy="itemThumb.mainImage" />
            </van-swipe-item>
            <!-- 自定义轮播索引 -->
            <template #indicator> 
              <div class="customIndicator">
                <div v-for="(itemIndex,index) in hotData" :key="'index'+index" class="indexall" :class="{'currentIndex':index==current}"></div>
              </div>
            </template>
          </van-swipe>
        </div>
        <!-- 列表数据 -->
        <div class="tabularData">
          <div v-for="(item,index) in dataLIst" :key="index" class="tabularDataItem" @click="toGoods(item.productId)">
              <div class="tabularDataItemBox">
                <div class="mainImageBox">
                  <img :src="item.mainImage" alt="">
                </div>
                <div class="goodsBox">
                  <div class="goodsName">{{item.subTitle}}</div>
                  <div class="goodsInfo">
                      <span class="price">{{shopOrintegral=="shop"?'￥'+item.currentUnitPrice:item.integral+' 积分'}}</span>
                      <span class="slogan">库存:{{item.stock}}</span>
                  </div>
                </div>
              </div>
          </div>
        </div>
      <!-- </switchCard> -->
    </mescroll-vue>
  </div>
</template>

<script>
// import switchCard from "./switchCard.vue";
// import searchContent from "./smallFunction/searchInput.vue";
// 引入mescroll的vue组件
import MescrollVue from "mescroll.js/mescroll.vue"; //上拉加载，下拉刷新
import Vue from 'vue';
import { Lazyload } from 'vant';
Vue.use(Lazyload);
export default {
  components: {
    // switchCard, //切换卡
    // searchContent ,//input框
    MescrollVue //上拉加载，下拉刷新
  },
  data() {
    return {
      classTitle: [], //分类
      current: 0, //轮播图索引
      hotData: [], //火热商品
      dataLIst:[], 
      
      mescrollUp: {
        //上拉加载下拉刷新
        callback: this.upCallback, // 上拉回调,此处可简写; 相当于 callback: function (page, mescroll) { getListData(page); }
        page: {
          num: 0, // 当前页码,默认0,回调之前会加1,即callback(page)会从1开始
          size: 10 // 每页数据的数量
        },
        htmlNodata: '<p class="upwarp-nodata">-- 到底啦 --</p>',
        noMoreSize: 5, // 如果列表已无数据,可设置列表的总数量要大于等于5条才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
        // toTop: {
        //   src: require("../../../assets/mescroll/mescroll-totop.png") // 回到顶部按钮的图片路径,支持网络图
        // },
        // empty: {
        //     // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
        //     warpId: 'listContent', // 父布局的id;
        //     icon: require('../../assets/mescroll/mescroll-empty.png'), // 图标,支持网络图
        //     tip: '暂无相关数据~', // 提示
        //     // btntext: '去逛逛 >', // 按钮,默认""
        //     // btnClick () { // 点击按钮的回调,默认null
        //     //     alert('点击了按钮,具体逻辑自行实现')
        //     // }
        // },
        auto: true,
        lazyLoad: {
          use: false // 是否开启懒加载,默认false
        }
      },
      mescroll:null,
    };
  },
  // 钩子函数
  created() {
    this.goodsListData(); //商品分类
    // this.pickoftheweek(); //推荐接口
  },
  methods: {
    // 跳转详情页面
    toGoods(id){
      this.$router.push({
        path: '/commodityDetails',
        query: {
          id:id
        }
      })
      // this.$router.push({path:'/commodityDetails?id='+id,})  //跳转到详情页面
    },
    // 商品分类接口
    goodsListData(){
      this.$http
        .post(
          this.javalinkTwo +
          "mmall/category/selectChildrenCategoryALLByCategoryIdForAPP?typeId=1"
        )
        .then(resp => {
          if (resp.data.success) {
            this.classTitle = resp.data.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // mescroll组件初始化的回调,可获取到mescroll对象
    mescrollInit(mescroll) {
      this.mescroll = mescroll;
    },
    // 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
    upCallback(page, mescroll){
      this.$http
      .post(
        this.javalinkTwo + "mmall/product/selectProductPageAPP?rows=10&sortBy=create_time&desc=true&page="+page.num,
        {
          typeId:1,
          num:5,
          productName:this.fenleiName, //名称搜索
					categroyId:this.fenleiId, //名称搜索
        }
      )
      .then(resp => {
        // console.log(resp.data);
        if(resp.data.success){
          if(page.num == 1){
            this.dataLIst = [];
            this.hotData=resp.data.data.hot; //火热商品
          }
          this.dataLIst=this.dataLIst.concat(resp.data.data.page.items);
          mescroll.endSuccess(resp.data.data.page.items.length);
        }else{
          mescroll.endErr();
        }
      })
      .catch(err => {
        mescroll.endErr();
        console.log(err);
      });
    },
    // 轮播图切换
    onChange(index) {
      //自定义索引
      this.current = index;
    }
  }
};
</script>

<style scoped>
.listOfCommodities{
  background: #F7F7F7;
}
.mySwipeBox {
  width: 100%;
  padding-bottom: 38%;
  position: relative;
  margin: 0px auto;
  overflow: hidden;
}
.lunboBackground {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 60%;
  border-radius: 0px 0px 10px 10px;
}
.thumbImg{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.my-swipe {
  position: absolute;
  top: 0px;
  left: 3%;
  width: 94%;
  height: 100%;
  border-radius: 5px;
}
.customIndicator{
  position: absolute;
  bottom: 5px;
  left: 0px;
  width: 100%;
  height: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tabularData{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0px 3%;
  box-sizing: border-box;
}
.tabularDataItem{
  width: 48.5%;
  margin-top: 3%;
  padding-bottom: 65%;
  background: #fff;
  border-radius: 4px;
  position: relative;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.tabularDataItemBox{
  position: absolute;
  top: 0px;
  left: 0px;
  width:100%;
  height: 100%;
}
.mainImageBox{
  width: 100%;
  height: 60%;
}
.mainImageBox img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.goodsBox{
  width: 100%;
  height:40%;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  align-content: center;
  flex-direction: column;
}
.goodsName{
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:2;
  margin-bottom: 15px;
}
.goodsInfo{
  display: flex;
  justify-content: space-between;
  font-size: 12px;
}
.price{
  color: #e65339;
}
.indexall{
  width: 12px;
  height: 3px;
  background-color: #ebedf0;
  opacity: 0.3;
  margin-left: 3px;
}
.indexall:last-child{
  margin-right: 3px;
}
.currentIndex{
  opacity: 1;
}

/* width: 6px;
    height: 6px;
    background-color: #ebedf0;
    border-radius: 100%;
    opacity: 0.3; */


/* .my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
} */
</style>